export default {
  name: 'transaction_frequency',
  component_path: 'modules/procedures/blocks/transaction/BlockTransactionFrequency'
}